<template>
  <div class="vdb-ticker">
    <template v-if="loading">
      <div class="vdb-ticker-row">
        <div class="vdb-ticker-dot" style="background: var(--cream-300)"></div>
        <div class="vdb-ticker-skel" style="width: 60px"></div>
        <div class="vdb-ticker-skel" style="width: 180px"></div>
        <div class="vdb-ticker-skel pill" style="width: 72px"></div>
        <div class="vdb-ticker-skel" style="width: 120px"></div>
      </div>
    </template>

    <template v-else-if="update">
      <div class="vdb-ticker-row">
        <div class="vdb-ticker-dot"></div>
        <div class="vdb-ticker-content">
          <ContentWithPills :content="formattedContent" />
        </div>
      </div>
    </template>

    <template v-else>
      <div class="vdb-ticker-row" style="color: var(--ink-400)">
        <div class="vdb-ticker-dot" style="background: var(--cream-300)"></div>
        <span>No updates available</span>
      </div>
    </template>
  </div>
</template>

<script>
import ContentWithPills from './ContentWithPills.vue';
import { videoApi } from '@/services/api.js';

export default {
  name: 'DailyUpdateTicker',
  components: {
    ContentWithPills
  },
  data() {
    return {
      update: null,
      loading: true // Start as true to show skeleton immediately
    };
  },
  computed: {
    formattedContent() {
      if (!this.update || !this.update.generated_content) return '';
      
      // Display TODAY's date (but we're fetching yesterday's update)
      const now = new Date();
      const today = new Date(now);
      
      const dateStr = today.toLocaleDateString('en-US', {
        timeZone: 'America/Los_Angeles',
        year: '2-digit',
        month: 'numeric',
        day: 'numeric'
      });
      
      const content = this.update.generated_content
        .replace(/more videos added/g, 'more added')
        .replace(/videos added/g, 'added');
      return `**${dateStr}** - ${content}`;
    }
  },
  async mounted() {
    await this.fetchLatestDailyUpdate();
  },
  methods: {
    async fetchLatestDailyUpdate() {
      try {
        this.loading = true;
        
        // Fetch the most recent daily update
        const response = await videoApi.get('/updates', {
          params: {
            update_type: 'daily',
            limit: 1,
            offset: 0
          }
        });

        if (response.data && response.data.data && response.data.data.length > 0) {
          this.update = response.data.data[0];
        }
      } catch (error) {
        console.error('Error fetching latest daily update:', error);
        // Silently fail - don't show error, just don't display ticker
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.vdb-ticker {
  padding: 8px 0 0;
}
.vdb-ticker-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: var(--ink-500);
  line-height: 1.5;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.vdb-ticker-row::-webkit-scrollbar {
  display: none;
}
.vdb-ticker-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4ade80;
  flex-shrink: 0;
  animation: vdb-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.vdb-ticker-content {
  display: inline;
}
/* Restyle taxonomy pills inside ticker to be subtle inline chips */
.vdb-ticker-content :deep(a),
.vdb-ticker-content :deep(span.inline-flex) {
  border: none !important;
  background: var(--cream-200, #f0ebe4) !important;
  color: var(--ink-700) !important;
  font-size: 12.5px !important;
  font-weight: 600 !important;
  padding: 2px 8px !important;
  border-radius: 6px !important;
  vertical-align: baseline;
  transition: background 0.15s ease;
}
.vdb-ticker-content :deep(a:hover) {
  background: var(--cream-400, #ddd6cb) !important;
  text-decoration: none;
}
.vdb-ticker-skel {
  height: 14px;
  border-radius: 4px;
  background: var(--cream-300);
  animation: vdb-pulse 1.5s ease infinite;
}
.vdb-ticker-skel.pill {
  height: 20px;
  border-radius: 6px;
}
@keyframes vdb-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>

